export const mockRegistriaRequestShippingAddress = {
  address1: '123 Main St',
  address2: 'Apt 4B',
  zip: '80202',
  city: 'Denver',
  state: 'CO',
  country: 'USA',
};
